import { Link } from "react-router-dom";

export default function SiteFooter() {
  return (
    <footer className="bg-primary-950 text-background-200 mt-16 pb-16 md:pb-0">
      <div className="wrap py-12 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 rounded-md bg-accent-500 text-background-50 flex items-center justify-center font-heading font-extrabold text-lg">
                无
              </span>
              <span className="font-heading font-extrabold text-lg text-background-50">无码</span>
            </div>
            <p className="text-sm leading-7 text-background-300 max-w-xs">
              以高清资源资讯为核心的内容门户，覆盖影视、动漫、音乐三大分类，帮助你在最短时间内找到想看的内容。
            </p>
            <div className="flex items-center gap-2 mt-5">
              <a
                href="mailto:hello@wuma-portal.example"
                aria-label="发送邮件"
                className="w-9 h-9 rounded-md border border-primary-800 flex items-center justify-center hover:border-accent-400 hover:text-accent-300 cursor-pointer transition-colors"
              >
                <i className="ri-mail-line" aria-hidden="true"></i>
              </a>
              <a
                href="https://51cgdaquan.asia"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="微博"
                className="w-9 h-9 rounded-md border border-primary-800 flex items-center justify-center hover:border-accent-400 hover:text-accent-300 cursor-pointer transition-colors"
              >
                <i className="ri-weibo-line" aria-hidden="true"></i>
              </a>
              <a
                href="https://www.wechat.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="微信"
                className="w-9 h-9 rounded-md border border-primary-800 flex items-center justify-center hover:border-accent-400 hover:text-accent-300 cursor-pointer transition-colors"
              >
                <i className="ri-wechat-line" aria-hidden="true"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">内容导航</h3>
            <ul className="space-y-2.5 text-sm">
              {[
                { label: "影视资源", to: "/category/movie" },
                { label: "动漫资源", to: "/category/anime" },
                { label: "音乐资源", to: "/category/music" },
                { label: "全站搜索", to: "/search" },
              ].map((item) => (
                <li key={item.to}>
                  <Link to={item.to} className="cursor-pointer text-background-300 hover:text-accent-300 transition-colors">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">站点信息</h3>
            <ul className="space-y-2.5 text-sm">
              {[
                { label: "关于无码", to: "/about" },
                { label: "内容覆盖范围", to: "/about" },
                { label: "使用说明", to: "/about" },
                { label: "版权与免责声明", to: "/about" },
              ].map((item) => (
                <li key={item.label}>
                  <Link to={item.to} className="cursor-pointer text-background-300 hover:text-accent-300 transition-colors">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">联系方式</h3>
            <ul className="space-y-2.5 text-sm text-background-300">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-accent-400" aria-hidden="true"></i>
                <a href="mailto:hello@wuma-portal.example" className="cursor-pointer hover:text-accent-300 transition-colors break-all">
                  hello@wuma-portal.example
                </a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-weibo-line mt-0.5 text-accent-400" aria-hidden="true"></i>
                <span>微博：@无码资源资讯</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-wechat-line mt-0.5 text-accent-400" aria-hidden="true"></i>
                <span>公众号：wuma-media</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-primary-900">
        <div className="wrap py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-400">
          <p>© 2024 无码资源资讯平台 · 本站内容均为虚构演示数据</p>
          <p className="text-center sm:text-right">
            本站不提供任何下载与播放服务，资源信息仅用于演示界面效果。
          </p>
        </div>
      </div>
    </footer>
  );
}